import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { useRouteMatch } from 'react-router-dom';
import { getInt } from 'utils/functions';
import { areas } from 'constants/areas';
import { Typography, IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { withAreaGetter } from 'providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { useReactiveVar } from '@apollo/client';
import { contentTypeNameVar } from '../variables';
import { ADMIN_DMS_READ } from 'constants/rightsCodes';
import ContentTypeGeneralDataContainer from './generalData/ContentTypeGeneralDataContainer';
import ContentTypeXMetadataContainer from './contentTypeXMetadata/ContentTypeXMetadataContainer';
import ContentTypeXUserGroupContainer from './contentTypeXUserGroup/ContentTypeXUserGroupContainer';
import PermissionCheck from 'components/common/PermissionCheck';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const { t } = useTranslation();
  const match = useRouteMatch();
  const contentTypeId = match.params.id && getInt(match.params.id);
  const contentTypeName = useReactiveVar(contentTypeNameVar);

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/contentTypes/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>{`${t('ContentTypes.Title')}:${
          contentTypeName ? ` ${contentTypeName}` : ' - / -'
        }`}</Typography>
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <IconButton
          tooltip={t('Tooltips.ContentTypes.BackToList')}
          color='transparent'
          onClick={() => historyContext.push(`/contentTypes`)}
        >
          <ArrowBack />
        </IconButton>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DMS_READ}>
        <ContentTypeGeneralDataContainer contentTypeId={contentTypeId} onRedirect={onRedirect} />
        <ContentTypeXMetadataContainer contentTypeId={contentTypeId} />
        <ContentTypeXUserGroupContainer contentTypeId={contentTypeId} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
